import { GridFiltersFormFields as fields } from './names';
import { CreatedBy, type TGridFiltersFormValues } from './types';

export const FILTER_MIN_AGE = 18;
export const FILTER_MAX_AGE = 65;

export const defaultGridFilters: TGridFiltersFormValues = {
	[fields.gender]: 'fem',
	[fields.createdBy]: CreatedBy.eva,
};
